export const askTigerLogoStyles = {
  root: "flex shrink-0 items-center justify-center rounded-full border border-muted bg-white shadow-md",
  badge: "h-[55%] w-[55%]",
};
